// src/services/validateToken.js
import {
  validateGoogleToken,
  isGoogleAuthenticated,
} from "./googleAuthService";
import { checkPHAdmin, resetAdminAuthorityCooldown } from "./adminAuthority";

// Env (proxy): VITE_API_BASE=/phapiv2, optional override for route
const base = import.meta.env.VITE_API_BASE;
const apiManagerRoute = import.meta.env.VITE_MANAGER_ROUTE;

const validateToken = async () => {
  let isValid = false;

  if (isGoogleAuthenticated()) {
    isValid = await validateGoogleToken();
  } else {
    const token = localStorage.getItem("jwtToken");
    if (!token) {
      isValid = false;
    } else {
      try {
        const res = await fetch(`${base}/${apiManagerRoute}/ValidateManager`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        isValid = res.ok;
      } catch (err) {
        console.error("Error validating token:", err);
        isValid = false;
      }
    }
  }

  if (isValid) {
    await checkPHAdmin();
  } else {
    sessionStorage.removeItem("IsPHAdmin");
    sessionStorage.removeItem("IsHubMedAdmin");
    resetAdminAuthorityCooldown();
  }

  return isValid;
};

export default validateToken;
